import {  useState } from "react";
import { addInsuranceInfo } from "../services/interface/InterfaceService";
import logo from "../components/assets/logo.svg";
import SelectInput from "../components/reusables/Select";
import { getTransactionReference} from "../utils/config";
const InsuranceInfo = () => {
  const [loading, setLoading] = useState({ button: false });
  
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  
  const [error, setError] = useState({
    customerName: false,
    customerPhoneNumber: false,
    InsuranceType: false,
    VehicleMake: false,
    VehicleModel: false,
    VehicleColor: false,
    VehicleYear: false,
    PlateNumber: false,
    ChassisNumber: false,
    EngineCapacity: false,
    InsuredName: false,
  });
  
  const [errorMessage, setErrorMessage] = useState({
    customerName: "",
    customerPhoneNumber: "",
    ChassisNumber: "",
    EngineCapacity: "",
    PlateNumber: "",
    InsuranceType: "",
    InsuredName: "",
    VehicleColor: "",
    VehicleMake: "",
    VehicleModel: "",
    VehicleYear: "",
  });

  const [formData, setFormData] = useState({
    insuranceType: "",
    vehicleMake: "",
    vehicleModel: "",
    vehicleColor: "",
    vehicleYear: "",
    plateNumber: "",
    chassisNumber: "",
    engineCapacity: "",
    insuredName: "",
    customerName: "",
    customerPhoneNumber: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    const numRegex = /^[0-9]*$/;
  
    let trimmedValue = value;
      
      if (name === "customerName") {
        setError((prevState) => ({ ...prevState, customerName: false }));
      }

       
      if (name === "customerPhoneNumber") {
        if (value?.length > 11) {
          return;
        }
        if (!numRegex.test(value)) {
          setError((prevState) => ({ ...prevState, [name]: true }));
          setErrorMessage((prevState) => ({
            ...prevState,
            [name]: `Phone number must be numbers`,
          }));
          return;
        } else {
          setError((prevState) => ({ ...prevState, [name]: false }));
        }
      }
    
      if (name === "insuranceType") {

        setError((prevState) => ({ ...prevState, InsuranceType: false }));
      }
      if (name === "vehicleModel") {
        setError((prevState) => ({ ...prevState, VehicleModel: false }));
      }
      if (name === "vehicleColor") {
        setError((prevState) => ({ ...prevState, VehicleColor: false }));
      }
      if (name === "vehicleYear") {
        setError((prevState) => ({ ...prevState, VehicleYear: false }));
      }
      if (name === "plateNumber") {
        setError((prevState) => ({ ...prevState, PlateNumber: false }));
      }
      if (name === "chassisNumber") {
        setError((prevState) => ({ ...prevState, ChassisNumber: false }));
      }
      if (name === "engineCapacity") {
        setError((prevState) => ({ ...prevState, EngineCapacity: false }));
      }
      if (name === "insuredName") {
        setError((prevState) => ({ ...prevState, InsuredName: false }));
      }
      if (name === "vehicleMake") {
        setError((prevState) => ({ ...prevState, VehicleMake: false }));
      }
      setFormData({
        ...formData,
        [name]: trimmedValue,
      });
    }

  const validateForm = () => {
    const {
      customerName,
      customerPhoneNumber,
      ChassisNumber,
      EngineCapacity,
      PlateNumber,
      InsuranceType,
      InsuredName,
      VehicleColor,
      VehicleMake,
      VehicleModel,
      VehicleYear,
    } = formData;

    let valid = true;
    const numRegex = /^[0-9]*$/;

    // Customer Name Validation
    if (customerName?.length < 2) {
      valid = false;
      setError((prevState) => ({ ...prevState, customerName: true }));
      setErrorMessage((prevState) => ({ ...prevState, customerName: "Name is too short" }));
    } else {
      setError((prevState) => ({ ...prevState, customerName: false }));
    }

    // Phone Number Validation
    if (!numRegex.test(customerPhoneNumber) || customerPhoneNumber?.length !== 11) {
      valid = false;
      setError((prevState) => ({ ...prevState, customerPhoneNumber: true }));
      setErrorMessage((prevState) => ({ ...prevState, customerPhoneNumber: "Invalid phone number" }));
    } else {
      setError((prevState) => ({ ...prevState, customerPhoneNumber: false }));
    }

    // Insurance Type Validation
    if (InsuranceType === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, InsuranceType: true }));
      setErrorMessage((prevState) => ({ ...prevState, InsuranceType: "Insurance Type is required" }));
    } else {
      setError((prevState) => ({ ...prevState, InsuranceType: false }));
    }

    // Vehicle Make Validation
    if (VehicleMake === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, VehicleMake: true }));
      setErrorMessage((prevState) => ({ ...prevState, VehicleMake: "Vehicle make is required" }));
    } else {
      setError((prevState) => ({ ...prevState, VehicleMake: false }));
    }

    // Vehicle Model Validation
    if (VehicleModel === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, VehicleModel: true }));
      setErrorMessage((prevState) => ({ ...prevState, VehicleModel: "Vehicle model is required" }));
    } else {
      setError((prevState) => ({ ...prevState, VehicleModel: false }));
    }

    // Vehicle Color Validation
    if (VehicleColor === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, VehicleColor: true }));
      setErrorMessage((prevState) => ({ ...prevState, VehicleColor: "Vehicle color is required" }));
    } else {
      setError((prevState) => ({ ...prevState, VehicleColor: false }));
    }

    // // Vehicle Year Validation
    // if (!numRegex.test(VehicleYear) || VehicleYear?.length !== 4) {
    //   valid = false;
    //   setError((prevState) => ({ ...prevState, VehicleYear: true }));
    //   setErrorMessage((prevState) => ({ ...prevState, VehicleYear: "Invalid vehicle year" }));
    // } else {
    //   setError((prevState) => ({ ...prevState, VehicleYear: false }));
    // }

    // Plate Number Validation
    if (PlateNumber === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, PlateNumber: true }));
      setErrorMessage((prevState) => ({ ...prevState, PlateNumber: "Plate number is required" }));
    } else {
      setError((prevState) => ({ ...prevState, PlateNumber: false }));
    }

    // Chassis Number Validation
    if (ChassisNumber === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, ChassisNumber: true }));
      setErrorMessage((prevState) => ({ ...prevState, ChassisNumber: "Chassis number is required" }));
    } else {
      setError((prevState) => ({ ...prevState, ChassisNumber: false }));
    }

    // Engine Capacity Validation
    if (EngineCapacity === "") {
      valid = false;
      setError((prevState) => ({ ...prevState, EngineCapacity: true }));
      setErrorMessage((prevState) => ({ ...prevState, EngineCapacity: "Engine capacity is required" }));
    } else {
      setError((prevState) => ({ ...prevState, EngineCapacity: false }));
    }

    // Insured Name Validation
    if (InsuredName?.length < 2) {
      valid = false;
      setError((prevState) => ({ ...prevState, InsuredName: true }));
      setErrorMessage((prevState) => ({ ...prevState, InsuredName: "Name is too short" }));
    } else {
      setError((prevState) => ({ ...prevState, InsuredName: false }));
    }

    return valid;
  };

  const validateErrors = () => {
    return Object.values(error).some((err) => err);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    if (validateErrors()) {
      return;
    }

    try {
      setLoading((prevState) => ({ ...prevState, button: true }));
      const reference = getTransactionReference();
      const redirectUrl = localStorage.getItem("gatewayurl");
      const insuranceResponse = await addInsuranceInfo(formData, reference);

      if(insuranceResponse){  
        window.open(redirectUrl, "_self");
      }
    } catch (error) {
      console.error("Error submitting insurance info", error);
    } finally {
      setLoading((prevState) => ({ ...prevState, button: false }));
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-transparent bg-gray-600">
    <div className="rounded-lg bg-white md:w-[700px] w-full  border-[1px] border-gray-200 shadow-sm px-5 py-5 relative pb-10 mx-auto text-center">
      <div className="flex flex-col pt-5 items-center text-center justify-center md:w-[75%] w-full md:mx-auto md:my-auto md:px-10">
        <div className="self-center mb-7">
          <img src={logo} alt="logo" />
        </div>
    <form
      onSubmit={handleSubmit}
      className="flex flex-col items-center justify-center"
    >

    <div className="flex flex-row justify-between md:w-[90%]">
        <h3 className="md:text-md text-sm items-center font-bold mt-4 text-center">
          Please provide your details to continue with the process.
        </h3>
    </div>
      <div className="md:w-[96%] w-full text-sm mt-8 flex flex-col gap-5">
        <div className="flex justify-between gap-3 flex-col md:flex-row">
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="bvn">
              FullName
            </label>
            <input
              name="customerName"
              id="customerName"
              value={formData.customerName}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your Fullname"
            />
            <small
              className={`${
                error.customerName ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.customerName}
            </small>
          </div>
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="nin">
              Phone Number
            </label>
            <input
              name="customerPhoneNumber"
              id="customerPhoneNumber"
              value={formData.customerPhoneNumber}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your Phone Number"
            />
            <small
              className={`${
                error.customerPhoneNumber ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.customerPhoneNumber}
            </small>
          </div>
        </div>
        <div className="flex justify-between gap-3 flex-col md:flex-row">
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="Surname">
            Chassis Number
            </label>
            <input
              name="chassisNumber"
              id="ChassisNumber"
              value={formData.chassisNumber}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your Chassis Number"
            />
            <small
              className={`${
                error.ChassisNumber ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.ChassisNumber}
            </small>
          </div>
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium" htmlFor="PlateNumber">
            Plate Number
            </label>
            <input
              name="plateNumber"
              id="PlateNumber"
              value={formData.plateNumber}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your plate number"
            />
            <small
              className={`${
                error.PlateNumber ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.PlateNumber}
            </small>
          </div>
  
        </div>
        <div className="flex justify-between gap-3 flex-col md:flex-row">
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="VehicleModel">
            Vehicle Model
            </label>
            <input
              name="vehicleModel"
              id="VehicleModel"
              value={formData.vehicleModel}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your vehicle model"
            />
            <small
              className={`${
                error.VehicleModel ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.VehicleModel}
            </small>
          </div>
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="VehicleColor">
            Vehicle Color
            </label>
            <input
              name="vehicleColor"
              id="VehicleColor"
              value={formData.vehicleColor}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your vehicle color"
            />
            <small
              className={`${
                error.VehicleColor ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.VehicleColor}
            </small>
          </div>
        </div>
        <div className="flex justify-between items-center gap-3 flex-col md:flex-row">
      
        <div className=" w-full flex flex-col gap-1 -mt-2 ">
          <SelectInput placeholder="Select your vehicle year" label="Vehicle year" data={Array.from({ length: 23 }, (_, i) => i + currentYear -21)} value={formData.vehicleYear} onChange={handleFormChange} name="vehicleYear" />
            <small
              className={`${
                error.VehicleYear ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.VehicleYear}
            </small>
          </div>
          <div className="md:w-[100%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium text-left md:text-center" htmlFor="InsuredName">
            Insured Name
            </label>
            <input
              name="insuredName"
              id="InsuredName"
              value={formData.insuredName}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter insured name"
            />
            <small
              className={`${
                error.InsuredName ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.InsuredName}
            </small>
          </div>
        </div>
        <div className="flex justify-between gap-3 flex-col md:flex-row">
        <div className="md:w-[50%] w-full flex flex-col gap-1 ">
          <SelectInput placeholder="Select engine capacity" label="Engine Capacity" data={["0.1 - 1.59", "1.6 - 2.0", "2.1 - 3.0", "3.1 - 12"]} value={formData.engineCapacity} onChange={handleFormChange} name="engineCapacity" />
            <small
              className={`${
                error.EngineCapacity ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.EngineCapacity}
            </small>
          </div> 
          <div className="md:w-[50%] w-full flex flex-col gap-1 ">
           
           <SelectInput placeholder="Select insurance type" label=" Insurance Type" data={["Third Party", "Comprehensive"]} value={formData.insuranceType} onChange={handleFormChange} name="insuranceType" />
           <small
             className={`${
               error.InsuranceType ? " opacity-100" : " opacity-0"
             } transition-opacity ease-in-out duration-500 text-red-500`}
           >
             {errorMessage.InsuranceType}
           </small>
         </div>   
        </div> 
        <div className="md:w-[50%] w-full flex flex-col gap-1 ">
            <label className="mx-1 font-medium" htmlFor="EmailAddress">
            Vehicle Make
            </label>
            <input
              name="vehicleMake"
              id="VehicleMake"
              value={formData.vehicleMake}
              onChange={handleFormChange}
              className="bg-transparent border-gray-300 h-12 border-[1px] py-2 px-2 rounded-lg outline-none"
              type="text"
              placeholder="Enter your vehicle make"
            />
            <small
              className={`${
                error.VehicleMake ? " opacity-100" : " opacity-0"
              } transition-opacity ease-in-out duration-500 text-red-500`}
            >
              {errorMessage.VehicleMake}
            </small>
          </div>
      </div>
      
      <button
        type={"submit"}
        onClick={ handleSubmit}
        disabled={loading.button}
        className="bg-[#161032] h-12 my-10 font-semibold text-lg flex items-center justify-center text-white py-3 rounded-lg hover:bg-[red] transition ease-in-out duration-300 w-[96%]"
      >
        {loading.button ? "Connecting..." : "Submit"}
      </button>
    </form>
    </div>
    </div>
    </div>
  );
};

export default InsuranceInfo;